export const ORDER_STATUS_COLORS = {
  received: "#fafafa",
  processing: "#ffeb3b",
  ready: "#64dd17",
};
